import {
  AbsoluteCenter,
  Spinner,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast,
  Stack,
  Tooltip,
  Box,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { EditIcon, AddIcon } from '@chakra-ui/icons';
import MultiSelect from 'components/autocomplete/autocomplete';
import SavingPlanVariantApi from 'api/savingplanvariant';
import SavingsPlanApi from 'api/savingplan';
import { categoryMap } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';
import { apiCall } from 'utils/fetchUtils';

const generatePeriodObjects = (periodFilterList) => {
  console.log('sorted period', periodFilterList);
  const obj = {
    value: '',
    label: 'Select Period',
  };
  const periodMap = periodFilterList.map((period) => ({
    label: `${period} months`,
    value: period,
  }));
  console.log('Distinct period objects', periodMap);
  return [obj, ...periodMap];
};

export default function TableData(props) {
  const { secondary } = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedFlavour, setselectedFlavours] = useState([]);
  const [categoryFilterList, setCategoryFilterList] = useState([]);
  const [periodFilterList, setPeriodFilterList] = useState([]);
  // const [totalPages, setTotalPages] = useState(0);
  const [booleanFilter, setBooleanFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1); // Added
  const [itemsPerPage, setItemsPerPage] = useState(10); // Added
  const [listTotal, setListTotal] = useState(2);
  const { getPermissionsForModule } = usePermissions();
  const [variantPermissions, setvariantPermissions] = useState(null);
  const [fetchVariantListError, setFetchVariantListError] = useState(false);

  console.log('Selected tyype is', selectedFlavour);
  const selectedValues = Array.isArray(selectedFlavour)
    ? selectedFlavour?.map((option) => option.value).join(',')
    : selectedFlavour.value;

  const selectedPeriod = Array.isArray(selectedOptions)
    ? selectedOptions?.map((option) => option.value).join(',')
    : selectedOptions.value;

  console.log('What is list', list, generatePeriodObjects(periodFilterList));
  console.log('Selected Value is', selectedValues);

  const onSuccess = (data) => {
    setOperationList(data?.list);
    setLoading(false);
  };
  const onVariantListSuccess = (data) => {
    setFetchVariantListError(false);
    console.log('Respoonse form variant', data);
    setList(data?.list);
    setCategoryFilterList(data?.categoryList);
    setPeriodFilterList(data?.monthList.sort((a, b) => a - b));
    setListTotal(data?.total);
    setLoading(false);
  };
  const onVariantError = () => {
    setFetchVariantListError(true);
    setLoading(false);
    setList(null);
    setListTotal(0);
  };

  useEffect(() => {
    const variantPermissions = getPermissionsForModule([
      Modules.SavingPlanVariant,
    ]);
    setvariantPermissions(variantPermissions);
    // FetchSavingPlanList();
    setLoading(true);
    apiCall(
      SavingPlanVariantApi.List,
      {
        currentPage,
        itemsPerPage,
        sort: 'updated_at:desc',
        searchTerm,
        booleanFilter,
        selectedValues,
        selectedPeriod,
      },
      variantPermissions?.read,
      onVariantListSuccess,
      onVariantError
    );
    apiCall(
      SavingsPlanApi.List,
      {
        currentPage: 1,
        itemsPerPage: 100,
        sort: 'name:asc',
      },
      variantPermissions?.read,
      onSuccess
    );
  }, [searchTerm, booleanFilter, selectedValues, selectedPeriod, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, booleanFilter, selectedValues, selectedPeriod]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  let totalPages = Math.ceil(listTotal / itemsPerPage);
  const pageItems = [];
  for (let i = 1; i <= totalPages; i++) {
    pageItems.push(
      <Button
        key={i}
        size='sm'
        variant='ghost'
        colorScheme={i === currentPage ? 'blue' : undefined}
        onClick={() => onPageChange(i)}
      >
        {i}
      </Button>
    );
  }
  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };

  if (!variantPermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlanVariant} />;
  }

  console.log('Permissions', variantPermissions);
  return fetchVariantListError ? (
    <PageError />
  ) : (
    <Flex height='100%' mt='8rem' direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}
      >
        <Flex>
          <MultiSelect
            options={categoryMap}
            value={selectedFlavour}
            placeholder='Select Category'
            onChange={setselectedFlavours}
            isMulti={false}
          />
        </Flex>
        <Flex>
          <MultiSelect
            options={generatePeriodObjects(periodFilterList)}
            isMulti={false}
            placeholder='Select Period'
            value={selectedOptions}
            onChange={setSelectedOptions}
          />
        </Flex>
        <Flex ml='auto'>
          {/* <Input
              variant='auth'
              type='text'
              placeholder='Search location..'
              onChange={(e) => handleSearch(e.target.value)}
            /> */}
          {/* <AddModal
              Icon={<AddIcon />}
              operationList={operationList}
              head={'Add'}
              func={fetchList}
            /> */}
          <Chakralink top='14px' right='14px'>
            <Link
              to={{
                pathname: `/admin/addvariant`,
              }}
            >
              <Tooltip
                label={
                  !variantPermissions.create
                    ? 'You do not have permission to add'
                    : undefined
                }
                placement='top'
                shouldWrapChildren
              >
                <Button
                  variant='lightBrand'
                  fontSize='sm'
                  fontWeight='500'
                  borderRadius='10px'
                  boxShadow='lg'
                  px='15px'
                  py='5px'
                  disabled={
                    !variantPermissions.create || !variantPermissions.read
                  }
                >
                  <AddIcon />
                </Button>
              </Tooltip>
            </Link>
          </Chakralink>
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}
      >
        <Table variant='striped' color='gray.500' mb='24px'>
          <Thead>
            <Tr>
              <Th pe='1px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Sr.no
                </Flex>
              </Th>
              <Th pe='5px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Category
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Period
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Minimum Investment
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Maximum Investment
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Pre-Mature Withdrawal Allowed
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Multiple Investments
                </Flex>
              </Th>

              <Th pe='5px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Availability
                </Flex>
              </Th>
              {/* <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Unit
                  </Flex>
                </Th> */}
              {/* <Th pe='10px' borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'
                  >
                    Status
                  </Flex>
                </Th> */}
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {
                          categoryMap.find(
                            (option) => option.value === obj?.category
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.period}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='5px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.min_investment}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.max_investment}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.premature_withdrawal_allowed ? 'True' : 'False'}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.multiple_investment}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.is_available ? 'True' : 'False'}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex justify='space-around'>
                      <Link
                        to={{
                          pathname: `/admin/editvariant/${obj.id}`,
                        }}
                      >
                        <Tooltip
                          label={
                            !variantPermissions.update
                              ? 'You do not have permission to edit'
                              : undefined
                          }
                          placement='top'
                          shouldWrapChildren
                        >
                          <Button
                            variant='auth'
                            fontSize='sm'
                            fontWeight='500'
                            borderRadius='10px'
                            px='15px'
                            py='5px'
                            disabled={
                              !variantPermissions.update ||
                              !variantPermissions.read
                            }
                          >
                            <EditIcon />
                          </Button>
                        </Tooltip>
                      </Link>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
